import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useT } from "@/i18n_extra3";
import { useLanguage } from "@/i18n";
import { BLOG_POSTS } from "@/data/blogPosts";

export const BlogSection = () => {
  const t = useT();
  const { lang } = useLanguage();
  return (
    <section className="py-28 sm:py-32 bg-[#FAF9F6]" data-testid="blog-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#B8860B]" />
            <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#B8860B]">{t.blogSection.label}</span>
          </div>
          <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl leading-[1.05] text-[#111111]">{t.blogSection.title}</h2>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-2 gap-8">
          {BLOG_POSTS.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
            >
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group block border border-black/10 rounded-2xl p-8 bg-white/60 hover:border-[#D4AF37] hover:shadow-xl transition-all duration-500 h-full"
              >
                <span className="text-[11px] font-bold tracking-widest uppercase text-[#B8860B]">{p.readMin} {t.blogSection.min}</span>
                <h3 className="mt-4 font-display font-semibold text-2xl leading-snug text-[#111111] group-hover:text-[#B8860B] transition-colors duration-300">
                  {p.title[lang] || p.title.en}
                </h3>
                <p className="mt-3 text-black/55 leading-relaxed">{p.excerpt[lang] || p.excerpt.en}</p>
                <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-[#B8860B]">
                  {t.blogSection.readMore} <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
